export const MOCK_USER = {
  name: "Alex Founder",
  streak: 14,
  totalEntries: 128,
  tags: ["#fundraising", "#productLaunch", "#burnout", "#deepWork", "#hiring", "#strategy", "#investorPitch", "#teamSync"]
};

export const MOOD_TYPES = [
  { id: 'stellar', label: 'Stellar', color: 'text-aurora', bgColor: 'bg-aurora/20', icon: 'Sun' },
  { id: 'flow', label: 'Flow State', color: 'text-aurora-light', bgColor: 'bg-aurora-light/20', icon: 'Wind' },
  { id: 'neutral', label: 'Balanced', color: 'text-gray-400', bgColor: 'bg-gray-400/20', icon: 'Circle' },
  { id: 'anxious', label: 'Anxious', color: 'text-lilac-light', bgColor: 'bg-lilac-light/20', icon: 'Zap' },
  { id: 'drained', label: 'Drained', color: 'text-lilac', bgColor: 'bg-lilac/20', icon: 'Moon' }
];

export const MOCK_ENTRIES = [
  {
    id: 1,
    date: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(),
    mood: 'flow',
    content: "Finalized the Series A deck. The narrative feels tight now. Deep work block from 8 AM to 11 AM is the only way to get this done without Slack noise.",
    tags: ["#deepWork", "#fundraising", "#strategy"]
  },
  {
    id: 2,
    date: new Date(Date.now() - 1000 * 60 * 60 * 24 * 0.8).toISOString(),
    mood: 'neutral',
    content: "Standard Tuesday. Team sync went well. Noted some friction in the engineering handoff, but we've got a plan to rectify it tomorrow.",
    tags: ["#teamSync", "#productLaunch"]
  },
  {
    id: 3,
    date: new Date(Date.now() - 1000 * 60 * 60 * 24 * 1.5).toISOString(),
    mood: 'anxious',
    content: "Investor update is due tomorrow. Still waiting on the final churn numbers from Q3. Feeling an underlying hum of stress about the growth trajectory.",
    tags: ["#fundraising", "#investorPitch"]
  },
  {
    id: 4,
    date: new Date(Date.now() - 1000 * 60 * 60 * 24 * 3).toISOString(),
    mood: 'stellar',
    content: "Closed the seed round! Unbelievable feeling. Taking the evening off to just breathe and appreciate the moment before the real work begins.",
    tags: ["#fundraising", "#milestone"]
  },
  {
    id: 5,
    date: new Date(Date.now() - 1000 * 60 * 60 * 24 * 4.2).toISOString(),
    mood: 'drained',
    content: "Back-to-back interviews all day. Context switching between technical screening and culture fit is exhausting. Need to delegate the first round.",
    tags: ["#hiring", "#burnout"]
  },
  {
    id: 6,
    date: new Date(Date.now() - 1000 * 60 * 60 * 24 * 6).toISOString(),
    mood: 'flow',
    content: "Architecture review. Caught a major edge case in the data pipeline that would have caused headaches next month. Feeling sharp.",
    tags: ["#deepWork", "#strategy"]
  }
];

export const MOCK_INSIGHTS = [
  {
    id: 'i1',
    title: "Flow State Correlation",
    description: "You consistently report 'Flow State' on days heavily tagged with #deepWork. Your peak efficiency window is 8 AM - 11 AM.",
    type: "positive"
  },
  {
    id: 'i2',
    title: "Anxiety Triggers",
    description: "The tag #fundraising appeared in 80% of your 'Anxious' entries this month. Consider scheduling regular decompression time.",
    type: "caution"
  }
];

export const generateHeatmapData = () => {
  const data = [];
  const today = new Date();
  for (let i = 29; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    const intensity = Math.floor(Math.random() * 5); 
    const isLilac = Math.random() > 0.6;
    data.push({
      date: d.toISOString(),
      intensity: intensity,
      color: intensity === 0 ? 'bg-ink-700' : 
             isLilac ? `bg-lilac/${intensity * 25}` : `bg-aurora/${intensity * 25}`
    });
  }
  return data;
};

export const DEMO_WORKFLOW = [
  {
    step: 1,
    title: "Bio-Sync Onboarding",
    description: "Connect your calendar and deep-work blocks to establish an activity baseline.",
    status: "completed",
    icon: "Activity"
  },
  {
    step: 2,
    title: "Rapid Reflection",
    description: "60-second daily check-in targeting 'mental RAM' usage and emotional frequency.",
    status: "active",
    icon: "Edit3"
  },
  {
    step: 3,
    title: "Pattern Extraction",
    description: "AI analyzes text for hidden triggers like #burnout or #deepWork without medical diagnosis.",
    status: "pending",
    icon: "Cpu"
  },
  {
    step: 4,
    title: "Resonance Detection",
    description: "Visualize how your energy levels correlate with specific projects or meetings.",
    status: "pending",
    icon: "Wifi"
  },
  {
    step: 5,
    title: "Narrative Synthesis",
    description: "Weekly automated report summarizing your emotional ROI and productivity peaks.",
    status: "pending",
    icon: "FileText"
  }
];